import React from 'react'
import Check from 'components/Form/Check'
import useI18n from 'hooks/useI18n'
import { PresetDescription, PresetHeading, PresetMessage, PresetSection } from './styled'

export default function ContentPresetSelector({ groups = [], loading, error, selectedId = [], onChange }) {
  const { t } = useI18n()

  return (
    <PresetSection>
      <PresetHeading>{t('staff_essentials_invites_content_preset_title')}</PresetHeading>
      <PresetDescription>{t('staff_essentials_invites_content_preset_description')}</PresetDescription>
      {groups.map(group => (
        <div key={group.documentId || group.id}>
          <Check
            label={`${group.name}${!group.contents.length ? ` — ${t('lite_invite_group_unavailable')}` : ''}`}
            checked={selectedId.includes(String(group.documentId || group.id))}
            disabled={loading || !group.contents.length}
            onChange={checked => onChange(checked
              ? [...selectedId, String(group.documentId || group.id)]
              : selectedId.filter(id => id !== String(group.documentId || group.id)))}
          />
          {group.description ? <PresetDescription>{group.description}</PresetDescription> : null}
        </div>
      ))}
      {loading ? <PresetMessage>{t('staff_essentials_invites_content_preset_loading')}</PresetMessage> : null}
      {!loading && error ? <PresetMessage error>{error}</PresetMessage> : null}
      {!loading && !error && !groups.length
        ? <PresetMessage>{t('staff_essentials_invites_content_preset_empty')}</PresetMessage>
        : null}
    </PresetSection>
  )
}
